import { cloneDeep } from 'lodash';

const defaultNetworkFilter = {
  currentPage: 1,
  pageSize: 10,
  order: '',
  orderBy: 'modifiedDate',
  filters: [],
};

const defaultStates = {
  networkwebsite: {
    hasFilterd: false,
    search: cloneDeep(defaultNetworkFilter),
    PlanCode: '',
    StateCode: '',
    County:"",
    ZipCode:"",
      City:"",
      PharmacyName:"",
       maxLatitude:"",
      minLatitude:"",
      maxLongitude:"",
      minLongitude:"",
    searchTerms: {
      PlanCode: '',
      StateCode: '',
      County:"",
      ZipCode:"",
      City:"",
      PharmacyName:"",
      maxLatitude:"",
      minLatitude:"",
      maxLongitude:"",
      minLongitude:"",
    },
  },
};

const initialStates = {
  loading: false,
  networkwebsite: cloneDeep(defaultStates.networkwebsite),
};

export { initialStates, defaultStates };
